/**
 * 拼单购物车
 */
import React, { FC, useEffect, useRef, useCallback, useMemo, Fragment } from 'react'
import { IonContent, IonFooter, IonPage } from '@ionic/react'
import { observer } from 'mobx-react'
import { restaurantCenter, orderMobx, cartMobx, orderFactory } from 'restaurant'
import { multiPersonOrderingMobx, multiPersonMobx, buyTogetherMobx, payPlanMobx, deliveryMobx } from '@mobxStore'
import { useHistoryNew, modalLayer } from '@utils'
import CashierController from '@ctrls/cashierController'
import { CartTop, CartStoreInfo, CartItems, CartFooter } from './components'
import { CartRemark, CartResultPrice } from '../checkout/component'
import { BTConfirmModal } from './modal'
import './index.scss'

interface IProps { }

const BuyTogetherCart: FC<IProps> = () => {
  const history = useHistoryNew()
  const timeRef = useRef(null)
  const { order } = orderMobx

  useEffect(() => {
    restaurantCenter.init()
    buyTogetherMobx.initCart()
    payPlanMobx.beginCalc()
    return () => {
      payPlanMobx.endCalc()
    }
  }, [])
  const isCanPay = useMemo(() => {
    return multiPersonMobx.getCurrentPersonInfo().isOwner && (cartMobx.cartItems.length > 0 || order?.ordersId)
  }, [cartMobx.cartItems, order?.ordersId, multiPersonMobx.getCurrentPersonInfo().isOwner])
  useEffect(() => {
    const multiPersonMap = multiPersonMobx.multiPersonMap
    if (multiPersonMobx.isInit && multiPersonMap && !multiPersonMap[buyTogetherMobx.getOwner]?.personId) {
      modalLayer(BTConfirmModal, {
        title: i18n.t('menu.buyTogetherTip.tipOver'),
        confirmText: i18n.t('menu.buyTogetherTip.buyNotSelf'),
        cancelText: i18n.t('menu.buyTogetherTip.buySelf'),
        canClose: false
      }, 'buyTogetherConfirmModal').then((res: any) => {
        if (res) {
          buyTogetherMobx.returnMenuPage('buyTogether', true)
        }
        // location.href = `/menu?ct=brand&b=${restaurantConfig.brandId}&s=${restaurantConfig.storeId || 0}`
      }).catch(async (res: any) => {
        buyTogetherMobx.returnMenuPage('', true)
      })
    }
    const meUser = multiPersonMobx.getCurrentPersonInfo()
    if (multiPersonMap?.[buyTogetherMobx.getOwner]?.personId) {
      let { address, eatType } = multiPersonMap?.[buyTogetherMobx.getOwner]
      if (meUser.isOwner) {
        eatType === 'delivery' && address && deliveryMobx.setAddress(address)
      } else {
        if (eatType) {
          eatType === 'delivery' && address && buyTogetherMobx.setAddress(address)
          if (buyTogetherMobx.eatType !== eatType) {
            buyTogetherMobx.setEatType(eatType)
            CashierController.switchEatType(eatType)
            console.toJS(multiPersonMobx.multiPersonMap, '🍰 输出拼单多人数据 ===> multiPersonMobx.multiPersonMap')
            console.toJS(buyTogetherMobx, '🍰 输出拼单mobx数据 ===> buyTogetherMobx')
          }
        }
      }
    }
  }, [multiPersonMobx.multiPersonMap])
  useEffect(() => {
    if (order.ordersId) {
      if (!multiPersonMobx.currentPersonInfo.isOwner) {
        if (order.status === 'Paying' || order.status === 'Pending') {
          clearInterval(timeRef.current)
          timeRef.current = setInterval(() => {
            orderFactory.getOrder(order.ordersId).then(res => {
              orderMobx.restore(res.result)
            })
          }, 5000)
        } else if (['Success', 'Timeout', 'Cancel'].includes(order.status)) {
          clearInterval(timeRef.current)
          // timeRef.current = null
        }
      }
      if (order.status === 'Success') {
        modalLayer(BTConfirmModal, {
          title: i18n.t(`menu.buyTogetherTip.${!multiPersonMobx.currentPersonInfo.isOwner ? 'other' : 'owner'}Payed`),
          confirmText: i18n.t('menu.buyTogetherTip.checkBill'),
          cancelText: i18n.t('common.back'),
          canClose: false
        }, 'buyTogetherConfirmModal').then((res: any) => {
          // multiPersonMobx.delCurrentPersonInfo()
          buyTogetherMobx.delStorage()
          history.push(`/billBuyTogether/${order.ordersId}`)
          // location.href = `/menu?ct=brand&b=${restaurantConfig.brandId}&s=${restaurantConfig.storeId || 0}`
        }).catch(async (res: any) => {
          if (res) {
            buyTogetherMobx.returnMenuPage('', true)
          }
        })
      } else if (order.status === 'Cancel') {
        multiPersonMobx.clearMultiPersonMap()
      }
    }
    return () => {
      clearInterval(timeRef.current)
    }
  }, [order.status, order.ordersId])

  const handleOutCart = useCallback(async () => {
    modalLayer(BTConfirmModal, {
      title: i18n.t('menu.buyTogetherTip.tipHaving'),
      confirmText: i18n.t('menu.buyTogetherTip.leaveBuy'),
      cancelText: i18n.t('menu.buyTogetherTip.cancelBuy'),
    }, 'buyTogetherConfirmModal').then((res: any) => {
      buyTogetherMobx.returnMenuPage('', false)
    }).catch(async (status: any) => {
      if (status) {
        if (buyTogetherMobx.getOwner === multiPersonMobx.getCurrentPersonInfo().personId) {
          multiPersonOrderingMobx.emitOrder({
            action: 'quitBB'
          })
        }
        await multiPersonMobx.delCurrentPersonInfo()
        buyTogetherMobx.returnMenuPage('', true)
      }
    })
  }, [])
  useEffect(() => {
    restaurantCenter.setConfig({
      eatType: buyTogetherMobx.eatType
    })
  }, [buyTogetherMobx.eatType])
  return (
    <IonPage className='btcart-page'>
      <Fragment key='btcart'>
        <IonContent>
          <div className='cart-content'>
            <CartTop handleOutCart={handleOutCart} />
            <CartStoreInfo />
            <CartItems handleOutCart={handleOutCart} />
            {
              isCanPay ? (
                <>
                  <CartRemark />
                  <CartResultPrice />
                </>
              ) : <div style={{ height: '60px' }}></div>
            }
          </div>
        </IonContent>
        <IonFooter>
          {
            isCanPay ? (
              <CartFooter handleOutCart={handleOutCart} />
            ) : null
          }
        </IonFooter>
      </Fragment>
    </IonPage>
  )
}

export default observer(BuyTogetherCart)
